export default __webpack_public_path__ + "static/media/bg3.6634a450.svg";